import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { classNameStrings } from '../../../../constants/base';
import Items from './items';
import Gem from './gem';

function ItemMain() {
  // -- props --//

  // -- component const --//
  const title = '아이템'

  // -- useSelector & dispatch --//

  // -- state --//
  const [className, setClassName] = useState('tab1');

  // -- func & handler --//

  // -- react hooks --//

  // -- render --//

  return (
    <div className='page'>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <div className="topSection flowRoot">
        <div className="leftSection">
          <p className="titleText">
            {title}
          </p>
        </div>

        <div className="rightSection">
          <button
            className={
              className === 'tab1' ? 'tab1 active' : 'tab1'
            }
            onClick={() => setClassName('tab1')}
          >
            아이템
          </button>
          <button
            className={
              className === 'tab2' ? 'tab2 active' : 'tab2'
            }
            onClick={() => setClassName('tab2')}
          >
            보석
          </button>
        </div>
      </div>

      <div className="spaceDiv10"/>

      <div className="divTaps">
        {className === 'tab1' && <Items />}
        {className === 'tab2' && <Gem />}
      </div>
    </div>
  );
}

export default ItemMain
